class ClusterVideo {
    constructor() {
        this.addListeners();
    }

    addListeners() {    
        
        const galleryLeft = document.getElementById('gallery-left');
        const galleryRight = document.getElementById('gallery-right');
        const gallerySmall = document.getElementById('gallery-small');
        const clickers = document.querySelectorAll('.gallery-wrapper');
        const modal = document.getElementById('videoGalleryModal');
        const imagemodal = document.getElementById('imagesGalleryModal');
        const galleryArray = document.querySelectorAll('.fansy-gallery-videos')
        const galleryPhotoArray = document.querySelectorAll('.fansy-gallery-photo')

        if (modal) {
            this.addModalListeners(modal)
        }

        if (imagemodal) {
            this.addImagesListeners(imagemodal)
        }

        if (galleryPhotoArray) {
            galleryPhotoArray.forEach(gallery => {
                const plays = gallery.querySelectorAll('.fansy-item-image')

                plays.forEach(play => {
                    play.addEventListener('click', this.openPhoto)
                })

            })
        }

        if (galleryLeft) {

            
            const buttons = document.querySelectorAll('.gallery-item-left');

            buttons.forEach(button => {

                button.addEventListener('click', (e) => {
                    
                    this.switchById(e.target.dataset.id, '.gallery-wrapper-left', buttons);
                })
            })
        }

        if (galleryArray) {
            galleryArray.forEach(gallery => {
                const plays = gallery.querySelectorAll('.fansy-item')

                plays.forEach(play => {
                    play.addEventListener('click', this.openVideo)                    
                })

            })
        }

        
        if (gallerySmall) { 

            const buttons = document.querySelectorAll('.gallery-item-small');

            buttons.forEach(button => {

                button.addEventListener('click', (e) => {
                    
                    this.switchById(e.target.dataset.id, '.gallery-wrapper-small', buttons);
                })
            })
        }
        
        if (galleryRight) {

            const buttons = document.querySelectorAll('.gallery-item-right');

            buttons.forEach(button => {
                button.addEventListener('click', (e) => {
                    this.switchById(e.target.dataset.id, '.gallery-wrapper-right', buttons);
                })
            })
        }

        clickers.forEach(item => {
            item.addEventListener('click', this.openVideo)
        })

    }

    addModalListeners(modal) {
        const close = document.getElementById('videoCloseButton')
        const content = modal.querySelector('.content')

        close.addEventListener('click', () => {
            modal.classList.remove('video-overlay--active')
            content.innerHTML = '';
            
        })

        window.addEventListener('click', (e) => {
            if (e.target.id == 'videoGalleryModal') {
                modal.classList.remove('video-overlay--active')
                content.innerHTML = '';
            }
        })

    }

    addImagesListeners(modal) {
        const close = document.getElementById('imagesCloseButton')
        const content = modal.querySelector('.content')

        close.addEventListener('click', () => {
            modal.classList.remove('images-overlay--active')
            content.innerHTML = '';
            
        })

        window.addEventListener('click', (e) => {
            if (e.target.id == 'imagesGalleryModal') {
                modal.classList.remove('images-overlay--active')
                content.innerHTML = '';
            }
        })

    }

    openVideo(e) {
        const modal = document.getElementById('videoGalleryModal')
        const content = modal.querySelector('.content')
        const width = content.offsetWidth;
        const height = Math.round(content.offsetWidth * 0.56)
        const link = e.target.dataset.link
        const type = e.target.dataset.type
        let iframe = ''

        switch (type) {
            case 'youtube':
                iframe = '<iframe width="' + width + '" height="' + height + '" src="' + link +'" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>'
                break;
            case 'vk':
                iframe = '<iframe src="' + link +'" width="' + width + '" height="' + height + '" allow="autoplay; encrypted-media; fullscreen; picture-in-picture;" frameborder="0" allowfullscreen></iframe>'
                break;
            case 'rutube':
                iframe = '<iframe width="' + width + '" height="' + height + '" src="' + link +'" frameBorder="0" allow="clipboard-write; autoplay" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>'
                break;
        }

        content.innerHTML = iframe;

        

        modal.classList.add('video-overlay--active')    
        
    }
    openPhoto(e) {

        const modal = document.getElementById('imagesGalleryModal')
        const content = modal.querySelector('.content')
        const image = e.target.dataset.image
        let img = '<img src="' + image + '">';
        modal.style.paddingTop = '100px';
        modal.classList.add('images-overlay--active')   
        content.innerHTML = img;
       
        const target = e.target
        const parent = target.parentElement

        let id = target.dataset.id

        const images = parent.querySelectorAll('.fansy-item-image')

        const counter = images.length - 1

        const nexts = modal.querySelectorAll('.next')
        const prevs =  modal.querySelectorAll('.prev')

        nexts.forEach(next => {
            next.addEventListener('click', () => {

                if (id < counter) {
                    id++
                } else {
                    id = 0
                }

                images.forEach(item => {
                    if (item.dataset.id == id) {
                        let newimage = item.dataset.image
                        content.innerHTML = '<img src="' + newimage + '">';
                    }
                })
                
            })
        })

       prevs.forEach(prev => {

            prev.addEventListener('click', () => {
                if (id == 0) {
                    id = counter
                } else {
                    id--
                }

                images.forEach(item => {
                    if (item.dataset.id == id) {
                        let newimage = item.dataset.image
                        content.innerHTML = '<img src="' + newimage + '">';
                    }
                })
                
            })
        })
       
    }
    
    switchById(id, classname, buttons) {


        const videos = document.querySelectorAll(classname);
        

        videos.forEach(video => {

            if(video.dataset.id == id) {

                video.classList.remove('gallery-wrapper--hidden');

            } else {
                video.classList.add('gallery-wrapper--hidden');
            }

        })

        buttons.forEach(button => {

            if(button.dataset.id == id) {
                button.classList.add('gallery-item--checked');
            } else {
                button.classList.remove('gallery-item--checked');
            }

        })

    }


}

export default ClusterVideo